import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import { selectWorks } from '../../../../Api/selectors';
import { REQUEST_VEHICLE } from '../../../constants';
import { VehicleCreateField } from './Fields';
import { render } from 'react-dom';

const Container = styled.div`
  width: 100%;

  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }
`;

const STATE = {};

class VehicleCreateStep3Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <VBox className="cols">
          <div className="info-card">
            <h2>{this.lbl('vehicle.create.columns.erdw_and_history')}</h2>
            <HBox flip={window.innerWidth < 768}>
              <VBox className="col">
                {[
                  'date_first_allowance',
                  'last_tenaamstelling',
                  'number_of_previous_owners',
                  'date_apk_expiry',
                  'wok',
                  'pending_recall',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} creditorInfo={this.props.creditorInfo} />
                ))}
              </VBox>

              <VBox className="col">
                {['model_year', 'production_date', 'delivered_from'].map(type => (
                  <VehicleCreateField key={type} type={type} />
                ))}
              </VBox>
              <VBox className="col">
                {['design'].map(type => (
                  <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} />
                ))}
              </VBox>
            </HBox>

            <HBox right center={window.innerWidth < 768}>
              <Button className="btn" primary onClick={this.prevStep.bind(this)} small>
                {this.lbl('previous')}
              </Button>

              <Button className="btn" primary onClick={this.save.bind(this)} small>
                {this.lbl('save')}
              </Button>
            </HBox>
          </div>
        </VBox>
      </Container>
    );
  }
}

VehicleCreateStep3Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep3 = compose(withConnect, withRouter)(VehicleCreateStep3Comp);
